import React, { useState, useEffect, useCallback } from 'react'
import { useTranslation } from "react-i18next";
import styles from './ModuleBuilder.module.css'
import { Tabs, Tab } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import FieldsManagment from './FieldsManagment';
import * as actions from '../../../../store/actions/index'
import { useSelector, useDispatch } from 'react-redux'
import LayoutManagment from './LayoutManagment/LayoutManagment';
import RelationshipManagment from './RelationshipManagment';

const ModuleBuilder = (props) => {
    const [activeTab, setActiveTab] = useState('all')
    const [t] = useTranslation('crm')
    const navigate = useNavigate();

    // const dispatch = useDispatch()


    const { crmState } = props
    // const { selectedCrmModule } = crmState

    const { name: moduleName, value: settingType } = crmState.crmPath
    const onNewTabSelectedHandler = useCallback((newTab) => {
        // setActiveTab(newTab)
        navigate(`/crm/${moduleName}/settings/${newTab}`)
    }, [moduleName])

    useEffect(() => {
        setActiveTab(settingType)
    }, [settingType])

    // useEffect(() => {
    // if(selectedCrmModule?.name !== moduleName)dispatch(actions.refreshCrmModule(moduleName))   
    // }, [])

    return (
        <Tabs id='module-builder-tabs' className={`cusTabs-contactlist open-contact-modal-tabs `} defaultActiveKey='all' activeKey={activeTab} onSelect={onNewTabSelectedHandler}>

            <Tab className={`${styles['modal-tab']}`} tabClassName={`${styles['details-tab']}`} eventKey='fields-managment' title={`${t('Fields managment')}`}>
                <FieldsManagment />
            </Tab>
            <Tab className={`${styles['modal-tab']}`} tabClassName={`${styles['details-tab']}`} eventKey='relationships' title={`${t('Module Relationships')}`}>
                <RelationshipManagment />
            </Tab>
            <Tab className={`${styles['modal-tab']}`} tabClassName={`${styles['details-tab']}`} eventKey='module-layout' title={`${t('Module layout')}`}>
                <LayoutManagment />
            </Tab>
        </Tabs>
    )
}
export default ModuleBuilder